import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { motion, useSpring } from "framer-motion";

export const MagneticCTA = ({
  to,
  href,
  children,
  variant = "outline",
  dark = false,
  className = "",
  testId,
  onClick,
  type,
  ariaLabel,
}) => {
  const ref = useRef(null);
  const x = useSpring(0, { stiffness: 180, damping: 16, mass: 0.4 });
  const y = useSpring(0, { stiffness: 180, damping: 16, mass: 0.4 });
  const [burst, setBurst] = useState(0);

  const onMove = (e) => {
    if (window.matchMedia("(pointer: coarse)").matches || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const dx = e.clientX - (r.left + r.width / 2);
    const dy = e.clientY - (r.top + r.height / 2);
    if (Math.hypot(dx, dy) < 120) {
      x.set(dx * 0.18);
      y.set(dy * 0.22);
    }
  };
  const onLeave = () => {
    x.set(0);
    y.set(0);
  };

  const base =
    "inline-block font-sans uppercase tracking-[0.2em] text-xs font-medium px-8 py-4 border transition-[background-color,color,border-color] duration-300 ease-out active:scale-[0.97]";
  const styles =
    variant === "solid"
      ? "bg-gold border-gold text-espresso hover:bg-champagne hover:border-champagne"
      : dark
      ? "bg-transparent border-ivory/70 text-ivory hover:bg-gold hover:border-gold hover:text-espresso"
      : "bg-transparent border-gold text-gold hover:bg-gold hover:text-espresso";

  const inner = (
    <motion.span style={{ x, y }} className={`${base} ${styles} ${className}`}>
      {children}
      {burst > 0 && (
        <motion.span
          key={burst}
          className="pointer-events-none absolute -top-3 -right-3"
          initial={{ scale: 0, opacity: 1, rotate: 0 }}
          animate={{ scale: 1.4, opacity: 0, rotate: 40 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 0C12.9 7.2 16.8 11.1 24 12C16.8 12.9 12.9 16.8 12 24C11.1 16.8 7.2 12.9 0 12C7.2 11.1 11.1 7.2 12 0Z" fill="#A9875F" />
          </svg>
        </motion.span>
      )}
    </motion.span>
  );

  const wrap = (node) => (
    <span
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      onMouseEnter={() => setBurst((b) => b + 1)}
      className="inline-block relative"
    >
      {node}
    </span>
  );

  if (href)
    return wrap(
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId}
        aria-label={ariaLabel || (typeof children === "string" ? children : undefined)}
      >
        {inner}
      </a>
    );
  if (to)
    return wrap(
      <Link to={to} data-testid={testId} aria-label={typeof children === "string" ? children : undefined}>
        {inner}
      </Link>
    );
  return wrap(
    <button type={type || "button"} onClick={onClick} data-testid={testId} className="relative">
      {inner}
    </button>
  );
};
